import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { DrillDown, DrillDownTable } from "./common_metadata.js"
import { TableFlexcelExportSettings } from "../common_metadata/flexcel_export.js"
import { Innosoft_InnoBI_Controllers_DynamicApiController as DynamicApi } from "../generated_api/generated_api.js"
import * as common_components from "../editor_common_components.js"
import { Helper } from "../../core/util/helper.js";
import React from "react";
interface TableProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: TableState;
    data: any;
}

export class StatisticResultTable extends React.Component<TableProps, any>{
    private gridRef;
    private grid: kendo.ui.Grid;
    private dynamicApi: DynamicApi;

    constructor(props) {
        super(props)
        this.state = {};
        this.dynamicApi = new DynamicApi();
    }

    handleDataChange = (data, pivotKeys, metaData) => {
        this.setState({ visibleValues: data, metaData: metaData });
    }

    shouldComponentUpdate(nextProps: TableProps, nextState) {
        return this.state.visibleValues !== nextState.visibleValues
            || this.props.metadataSettings.pageSize != nextProps.metadataSettings.pageSize
            || this.props.metadataSettings !== nextProps.metadataSettings
            || this.props.queryParameter !== nextProps.queryParameter
            || this.state.maxAxisValue != nextState.maxAxisValue
            || this.state.isSaving !== nextState.isSaving
            || this.props.metadataSettings.resizable !== nextProps.metadataSettings.resizable;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.metadataSettings != prevProps.settings || this.state.metaData != prevState.metaData || this.state.visibleValues != prevState.visibleValues) {
            let s = this.createGridSettings(this.state.visibleValues)
            this.grid.setOptions(s);

        }

        if (this.state.visibleValues != prevState.visibleValues) {
            this.grid.dataSource.page(1);
        }
    }

    getColumnTemplate = (column, row, dictName?, columnDesc?, columnKey?) => {

        try {
            let template = kendo.template(column.template);
            let templateData: any = { row: row, context: this.props.context.variables }
            if (dictName && columnDesc && columnKey) {
                templateData.columnDescription = columnDesc;
                templateData.columnsDictionary = row[dictName];
                templateData.columnData = row[dictName][columnKey];
            }
            var result = template(templateData);
        }
        catch (e) {
            return '<div style = "color:red">Error im template:' + e.message + '</div>';
        }
        return result
    }

    getGroupHeaderTemplate = (templateDefinition: string, value, items) => {

        try {
            let template = kendo.template(templateDefinition);
            let templateData: any = { value: value, items: items, context: this.props.context.variables }
            var result = template(templateData);
        }
        catch (e) {
            return '<div style = "color:red">Error im template:' + e.message + '</div>';
        }
        return result
    }
    createSimpleColumn = (column, meta, aggregates) => {
        let c: any = { title: column.header, field: utility.generateColumnName(column.columnName), width: column.width };
        var align = column.align;
        if (align) {
            c.attributes = { style: "text-align:" + align };
        }
        var format = column.format;
        if (format) {
            c.format = '{0:' + format + '}';
        }
        else if (meta && meta[column.columnName] && meta[column.columnName] == "number") {
            c.format = "{0:n2}"
        }

        if (column.showSum) {
            const formatTemplate = (!c.format) ? "sum ?kendo.toString(sum, 'n2'):''" : `kendo.toString(sum, '${(format || '').replace('#', '\\#')}')`
            c.footerTemplate = `#=${formatTemplate}#`;
            c.groupFooterTemplate = `#=${formatTemplate}#`;
            aggregates.push({ field: c.field, aggregate: "sum" });
        }
        return c;
    }

    createTemplateColumn = (column) => {
        let c: any = { title: column.header, width: column.width };
        var template = column.template;
        if (template && template != "") {
            c.template = (row) => this.getColumnTemplate(column, row);
        }
        return c;
    }

    createLinkTemplate = (linkParams, row) => {
        const linkType = linkParams._Object_Type;

        if (linkType == "Link to project") {
            return `<a  target ="blank" href ="${this.props.context.variables.INNO_BASE_PATH}project/Edit?id=${row[linkParams.projnr]}">${row[linkParams.displayField]}</a>`;
        }
        else if (linkType == "Link to assignment") {
            return `<a  target ="blank" href ="${this.props.context.variables.INNO_BASE_PATH}ResourcePlanningScheduler?projNr=${row[linkParams.projnr]}&pIndex=${row[linkParams.pindex]}">${row[linkParams.displayField]}</a>`
        }
    }

    createLinkColumn = (column) => {
        let c: any = { title: column.header, width: column.width };
        const linkParams = column.linkParams;
        if (linkParams) {
            c.template = (row) => this.createLinkTemplate(linkParams, row);
        }
        return c;
    }

    createGeneratorColumn = (column, data, aggregates) => {
        if (!data) {
            return [];
        }
        //Liste von untergeodneten Elementen in einem Array wird in ein Objekt umgewandelt. [{key:1, value:4},{key:2, value:14}] wird zu {1:{key:1,value:4}, 2:{key:2,value:14}}
        const arrayColumn = column.nestedColumn;
        const keyField = column.keyField;
        const dictName = "dict_" + arrayColumn + "_" + keyField;
        if (!arrayColumn || !keyField) {
            return [];
        }

        const allKeys: any = {};
        for (let row of data) {
            if (row[arrayColumn] && row[arrayColumn][0][keyField]) {
                row[dictName] = {};
                for (let rowInArrayColumn of row[arrayColumn]) {
                    const validColumnName = utility.generateColumnName(String(rowInArrayColumn[keyField]));
                    allKeys[validColumnName] = rowInArrayColumn;
                    row[dictName][validColumnName] = rowInArrayColumn;
                }
            }
        }

        for (let row of data) {
            if (!row[dictName]) {
                row[dictName] = {};
            }

            for (let k in allKeys) {
                if (!row[dictName][k]) {
                    row[dictName][k] = {}
                }
            }
        }

        const newColumns = [];
        const columns = column.columns;
        if (columns) {
            for (let k in allKeys) {
                for (let i = 0; i < columns.length; i++) {
                    const c = this.generateArrayColumn(columns[i], aggregates, allKeys[k], keyField, dictName, k);
                    if (c) {
                        newColumns.push(c)
                    }
                }
            }
        }
        return newColumns;
    }

    generateArrayColumn = (column, aggregates, values, keyField, dictName, k) => {
        const valueField = column.valueField;
        const headerField = column.headerField;
        if (!valueField || !headerField) {
            return null;
        }

        const columnParams = values;
        const c: any = { title: String(columnParams[headerField] || columnParams[keyField]), field: dictName + "." + k + "." + valueField, width: column.width };
        const format = column.format;

        if (format) {
            c.format = '{0:' + format + '}';
        }

        var align = column.align;
        if (align) {
            c.attributes = { style: "text-align:" + align };
        }

        var template = column.template;
        if (template && template != "") {
            c.template = (row) => this.getColumnTemplate(column, row, dictName, c, k);
        }

        if (column.showSum) {
            const alignTemplate = (align || "left");
            const formatTemplate = (!c.format) ? "sum ? kendo.toString(!sum ? 0 : sum, '\\#'):''" : `sum ?kendo.toString(sum, '${(format || '').replace('#', '\\#')}'):''`
            c.footerTemplate = `#=${formatTemplate}#`;
            aggregates.push({ field: c.field, aggregate: "sum" });
        }
        return c;
    }

    createHeaderColumn = (column, meta, data, aggregates) => {
        const c: any = {
            title: column.header
        };
        if (column.style) {
            c.headerAttributes = {
                style: column.style
            };
        }
        const childColumns = this.createColumns(column.childColumns, meta, data, aggregates);
        if (Array.isArray(childColumns) && childColumns.length > 0) {
            c.columns = childColumns;
        }
        return c;
    }

    createColumns = (columns, meta, data, aggregates): any => {
        var kendoColumns: any[] = [];
        if (Array.isArray(columns) && columns.length > 0) {

            for (let i = 0; i < columns.length; i++) {
                const column = columns[i];
                const columnType = column._Object_Type;
                let c: any;

                if (columnType == "simpleColumn") {
                    const newColumn = this.createSimpleColumn(column, meta, aggregates);
                    kendoColumns.push(newColumn);
                }
                else if (columnType == "templateColumn") {
                    kendoColumns.push(this.createTemplateColumn(column));
                }
                else if (columnType == "headerColumn") {
                    kendoColumns.push(this.createHeaderColumn(column, meta, data, aggregates));
                }
                else if (columnType == "linkColumn") {
                    kendoColumns.push(this.createLinkColumn(column));
                }
                else if (columnType == "generatorColumn") {
                    kendoColumns = kendoColumns.concat(this.createGeneratorColumn(column, data, aggregates));
                }
                else {
                    c = { title: column.header, field: utility.generateColumnName(column.columnName), width: column.width };
                    var align = column.align;
                    if (align) {
                        c.attributes = { style: "text-align:" + align };
                    }
                    var format = column.format;
                    if (format) {
                        c.format = '{0:' + format + '}';
                    }
                    else if (meta && meta[column.columnName] && meta[column.columnName] == "number") {
                        c.format = "{0:n2}"
                    }

                    if (column.style) {
                        c.headerAttributes = {
                            style: column.style
                        };
                    }
                    if (column.groupHeaderTemplate) {
                        c.groupHeaderTemplate = (a) => this.getGroupHeaderTemplate(column.groupHeaderTemplate, a.value, a.items);
                    }

                    var template = column.template;
                    if (template && template != "") {
                        c.template = (row) => this.getColumnTemplate(column, row);
                    }
                    if (this.props.metadataSettings.isFilterable && meta && meta[column.columnName] == "string") {
                        c.filterable = { multi: true, search: true };//{ cell: { operator: "contains" } }
                    }
                    if (column.showSum) {
                        const formatTemplate = (!c.format) ? "sum ?kendo.toString(sum, 'n2'):''" : `kendo.toString(sum, '${(format || '').replace('#', '\\#')}')`
                        c.footerTemplate = `#=${formatTemplate}#`;
                        c.groupFooterTemplate = `#=${formatTemplate}#`;
                        aggregates.push({ field: c.field, aggregate: "sum" });
                    }

                    kendoColumns.push(c);
                }
            }
        }
        else {
            kendoColumns = [{ title: "dummy", field: "dummy" }];
        }
        return kendoColumns;
    }

    createGridSettings = (data: any[]) => {

        let columns = this.props.metadataSettings.columns;
        let pageSize = this.props.metadataSettings.pageSize || 200;
        let meta = this.state.metaData;
        const aggregates = [];
        var kendoColumns = this.createColumns(columns, meta, data, aggregates);

        const that = this;
        let height = this.props.metadataSettings.height ? this.props.metadataSettings.height : 600;
        const selectable = (this.props.metadataSettings.drillDownList?.length > 0 || this.props.metadataSettings.exports?.length > 0) ? "multiple, row" : false;
        let gridConfig: any = {
            excel: {
                fileName: "export.xlsx",
                allPages: true,
            },
            pdf: {
                allPages: true,
                fileName: "export.pdf"
            },
            dataSource: {
                data: data,
                pageSize: pageSize
            },
            height: height,
            sortable: true,
            columns: kendoColumns,
            pageable: {
                refresh: false,
                pageSizes: false,
                buttonCount: 5
            },
            resizable: this.props.metadataSettings.resizable ?? false,
            selectable: selectable,
            change: function (e) {
                var selectedRows = this.select();
                var selectedDataItems = [];
                for (var i = 0; i < selectedRows.length; i++) {
                    var dataItem = this.dataItem(selectedRows[i]);
                    selectedDataItems.push(dataItem);
                    that.setState({ selectedItems: selectedDataItems });
                }
            }
        };

        if (Helper.hasValue(this.props.metadataSettings.isPageable) && !this.props.metadataSettings.isPageable) {
            gridConfig.pageable = false;
        }

        if (Helper.hasValue(this.props.metadataSettings.isSortable) && !this.props.metadataSettings.isSortable) {
            gridConfig.sortable = false;
        }

        if (this.props.metadataSettings.isFilterable) {
            gridConfig.filterable = true;
        }

        if (meta) {
            let fields: any = {};
            for (let key in meta) {
                const hashCode = utility.generateColumnName(key);
                fields[hashCode] = { from: `["${key}"]`, type: meta[key] };
            }
            gridConfig.dataSource.schema = { model: { fields: fields } };
        }
        else if (data && data.length > 0) {
            let fields: any = {};
            for (let key in data[0]) {
                const hashCode = utility.generateColumnName(key);
                fields[hashCode] = { from: `["${key}"]` };
            }
            gridConfig.dataSource.schema = { model: { fields: fields } };
        }

        const groupingFields = this.props.metadataSettings.groupingFields;
        if (groupingFields && groupingFields.length > 0) {
            const groups = groupingFields.filter((val) => val.groupingField).map((val) => {
                const gr: any = { field: utility.generateColumnName(val.groupingField), dir: val.sortDirection ?? "asc" }
                if (aggregates) {
                    gr.aggregates = aggregates;
                }
                return gr;
            });
            if (groups.length > 0) {
                gridConfig.dataSource.group = groups
            }
        }
        else {
            gridConfig.dataSource.group = [];
        }

        if (aggregates.length > 0) {
            gridConfig.dataSource.aggregate = aggregates;
        }

        return gridConfig;
    }

    createGrid = (data) => {
        data = data || [];
        var that = this;
        var $rootNode = $(this.gridRef);

        var grid = $rootNode.kendoGrid(this.createGridSettings(data));

        this.grid = grid.data("kendoGrid");
    }

    componentDidMount() {
        this.createGrid(this.props.data);
    }

    drillDown = (statisticId: string, destField, sourceField) => {

        if (statisticId && statisticId != "" && this.state.selectedItems) {
            var newObj: any = $.extend({}, this.props.queryParameter);
            newObj[destField] = this.state.selectedItems.map((item) => item[sourceField]);
            var params = newObj;
            this.props.context.drillDownObject.requestDrillDown(params, statisticId, this.state.selectedItems);
        }
    }

    handleExcelExport = (e) => {
        this.grid.saveAsExcel();
        e.preventDefault();
    }

    handlePdflExport = (e) => {
        this.grid.saveAsPDF();
        e.preventDefault();
    }

    createToolbar = () => {

        let selectAllButton = null;
        if ((this.props.metadataSettings.drillDownList && this.props.metadataSettings.drillDownList.length > 0) || (this.props.metadataSettings.exports && this.props.metadataSettings.exports.length > 0)) {
            selectAllButton = <a className="k-button k-button-icontext k-grid-pdf" href="#" onClick={this.handleSelectAll}>
                Select all
            </a>
        }

        return (
            <div className="k-header k-grid-toolbar" style={{ backgroundColor: "#f3f3f4", display: "flex", alignItems: "center" }}>
                <a className="k-button k-button-icontext k-grid-excel" href="#" onClick={this.handleExcelExport}>
                    <span className="k-icon k-i-excel"></span>
                </a>
                <a className="k-button k-button-icontext k-grid-pdf" href="#" onClick={this.handlePdflExport}>
                    <span className="k-icon k-i-pdf"></span>
                </a>
                {this.createExportMenu()}
                {selectAllButton}
                {this.createDrillDownMenu()}
            </div>
        )
    }
    createDrillDownMenu = () => {

        const drillDownList = this.props.metadataSettings.drillDownList;

        if (!drillDownList || drillDownList.length == 0) {
            return null;
        }

        const links = drillDownList.map((drill) => {
            return <a className="k-button k-button-icontext k-grid-excel" onClick={this.drillDown.bind(this, drill.statisticId, drill.destField, drill.sourceField)}>
                {drill.label}
            </a>
        });

        return <div className="btn-group">
            <ul className="dropdown-menu" role="menu">
                {links}
            </ul>
        </div>
    }

    downloadFile = (statisticExport: TableFlexcelExportSettings) => {
        this.setState({ isSaving: true });
        const serviceId = statisticExport.dataSource.getDatasourceServiceId();
        let newObj: any[] = this.state.selectedItems ? this.state.selectedItems.map((item) => { return { "key": "selected_keys", "value": item[statisticExport.keyField] } }) : [];

        for (var key of Object.keys(this.props.queryParameter)) {
            if (Array.isArray(this.props.queryParameter[key])) {
                for (var value of this.props.queryParameter[key]) {
                    newObj.push({ "key": key, "value": value });
                }
            }
            else {
                newObj.push({ "key": key, "value": this.props.queryParameter[key] });
            }
        }

        this.dynamicApi.GenerateFile(serviceId, statisticExport.excelTemplateName, newObj, (filename) => {
            const url = "api/DynamicApi/" + serviceId + "/GetFileByName?filename=" + filename;
            Helper.openInNewBrowserTab(url);
            this.setState({ isSaving: false });
        }, () => {
            this.setState({ isSaving: false });
        })
    }

    createExportMenu = () => {

        const exportList = this.props.metadataSettings.exports;

        if (!exportList || exportList.length == 0) {
            return null;
        }

        const filteredExports = this.props.metadataSettings.exports.filter(statisticExport => { return statisticExport.dataSource && statisticExport.dataSource.getDatasourceServiceId() && statisticExport.keyField });
        if (filteredExports.length == 0) {
            return null;
        }


        const links = filteredExports.map((statisticExport) => { return <li><a onClick={this.downloadFile.bind(this, statisticExport)}> {statisticExport.label}</a></li> });
        return <div className="btn-group">
            <ul className="dropdown-menu" role="menu">
                {links}
            </ul>
        </div>
    }

    handleSelectAll = (e) => {
        this.grid.select(this.grid.tbody.find(">tr"));
        e.preventDefault();
    }

    renderAlternateRowColorStyles = () => {
        const firsRowSytyle = `
    #x${this.props.metadataSettings.uid} .k-grid-content tr {
      background-color:red;
    }`;

        const alternateRowSytyle = `
   #x${this.props.metadataSettings.uid}  .k-grid-content .k-alt {
      background-color:${this.props.metadataSettings.alternateRowColor};
    }`;

        const rowsStyle = alternateRowSytyle;

        return (
            this.props.metadataSettings.alternateRowColor ?
                <style>
                    {rowsStyle}
                </style>
                : null
        )
    }

    render() {
        const alldataSources = FindDataSourceProperties(this.props.metadataSettings);
        let busyIndicator = this.state.isSaving === true ? <common_components.BusyIndicatorDialog title="Generating file" /> : null;

        return (
            <div>
                <react_components.ReactColumn width={this.props.metadataSettings.width} >
                    {busyIndicator}
                    <react_components.ReactDataPager
                        dataSource={this.props.metadataSettings.dataSource}
                        allDatasources={alldataSources}
                        uid={this.props.uid} context={this.props.context}
                        titel={this.props.metadataSettings.titel}
                        enablePagging={false} pageSize={0}
                        queryParameter={this.props.queryParameter} onVisibleDataChange={this.handleDataChange}>
                        {this.props.metadataSettings.showTableMenu ?? true ? this.createToolbar() : null}
                        <div id={'x' + this.props.metadataSettings.uid} ref={(e) => this.gridRef = e}></div>
                    </react_components.ReactDataPager>
                </react_components.ReactColumn>
            </div>
        );
    }
};



export class TableState extends propertyTypes.BaseComponentProps {
    private heightMetadata = new propertyTypes.TextProperty("height", "Height");
    public height: string;

    private titelMetadata = new propertyTypes.TranslatableTextProperty("titel", "Title");
    public titel: string;

    private pageSizeMetadata = new propertyTypes.TextProperty("pageSize", "Page size");
    public pageSize: string;

    private isFilterableMetadata = new propertyTypes.CheckBoxProperty("isFilterable", "Is filterable");
    public isFilterable: string;

    private isPageableMetadata = new propertyTypes.CheckBoxProperty("isPageable", "Is pageable", true);
    public isPageable: string;

    private isSortableMetadata = new propertyTypes.CheckBoxProperty("isSortable", "Is sortable", true);
    public isSortable: string;

    private alternateRowColorMetadata = new propertyTypes.TextProperty("alternateRowColor", "Alternate row color", false);
    public alternateRowColor: string;

    private showTableMenuMetadata = new propertyTypes.CheckBoxProperty("showTableMenu", "Show table menu", true);
    public showTableMenu: string;

    private resizableMenuMetadata = new propertyTypes.CheckBoxProperty("resizable", "Resizable columns", false);
    public resizable: boolean;

    public dataSource: datasources.Datasource;

    private drilldownMetadata = new propertyTypes.ObjectListPropertyExt("drillDownList", "Drilldown")
        .addStateImplementation("drillDownList", DrillDownTable);
    public drillDownList: DrillDownTable[];

    private columnsMetadata = new propertyTypes.ObjectListPropertyExt("columns", "Columns")
        .addStateImplementation("default", Column)
        .addStateImplementation("headerColumn", HeaderColumn)
        .addStateImplementation("simpleColumn", SimpleColumn)
        .addStateImplementation("templateColumn", TemplateColumn)
        .addStateImplementation("generatorColumn", ArrayColumn);
    public columns: (Column | HeaderColumn | SimpleColumn | TemplateColumn | ArrayColumn)[];

    private groupingFieldsMetadata = new propertyTypes.ObjectListPropertyExt("groupingFields", "Grouping fields")
        .addStateImplementation("groupingField", GroupingField);
    public groupingFields: GroupingField[];

    private exportMetadata = new propertyTypes.ObjectListPropertyExt("exports", "Exports")
        .addStateImplementation("flexcel", TableFlexcelExportSettings);

    public exports: TableFlexcelExportSettings[];

    private selectMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.selectMetadataAll = baseMetaData.concat([
            this.heightMetadata, this.titelMetadata, this.pageSizeMetadata, this.isFilterableMetadata, this.isSortableMetadata, this.isPageableMetadata,
            this.alternateRowColorMetadata, this.resizableMenuMetadata,
            datasources.dataSourceMetadata, this.columnsMetadata, this.groupingFieldsMetadata, this.drilldownMetadata, this.exportMetadata,
            this.showTableMenuMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.selectMetadataAll;
    }
}


class Column extends propertyTypes.Serializable {
    private headerMetadata = new propertyTypes.TranslatableTextProperty("header", "Header")
    public header: string;

    private columnNameMetadata = new propertyTypes.ColumnProperty("columnName", "Column name", "dataSource")
    public columnName: string;

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private alignMetadata = new propertyTypes.SelectProperty("align", "Align")
        .addOption("left", "Left")
        .addOption("center", "Center")
        .addOption("right", "Right");
    public align: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    private formatMetadata = new propertyTypes.TextProperty("format", "Format");
    public format: string;

    private styleMetadata = new propertyTypes.TextProperty("style", "Column style");
    public style: string;

    private showSumMetadata = new propertyTypes.CheckBoxProperty("showSum", "Show sum in footer");
    public showSum: string;

    private groupHeaderTemplateMetadata = new propertyTypes.TemplateProperty("groupHeaderTemplate", "Group header template");
    public groupHeaderTemplate: string;

    private columnMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.columnMetadata = [this.headerMetadata, this.columnNameMetadata, this.templateMetadata, this.alignMetadata, this.widthMetadata, this.formatMetadata, this.styleMetadata, this.showSumMetadata, this.groupHeaderTemplateMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.columnMetadata;
    }
}

class HeaderColumn extends propertyTypes.Serializable {
    private headerMetadata = new propertyTypes.TranslatableTextProperty("header", "Header")
    public header: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    private styleMetadata = new propertyTypes.TextProperty("style", "Column style");
    public style: string;

    private columnsMetadata = new propertyTypes.ObjectListPropertyExt("childColumns", "Child columns")
        .addStateImplementation("default", Column)
        .addStateImplementation("headerColumn", HeaderColumn)
        .addStateImplementation("simpleColumn", SimpleColumn)
        .addStateImplementation("templateColumn", TemplateColumn)
        .addStateImplementation("generatorColumn", ArrayColumn);

    public childColumns: (Column | HeaderColumn | SimpleColumn | TemplateColumn | ArrayColumn)[];

    private headerColumnMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.headerColumnMetadata = [this.headerMetadata, this.widthMetadata, this.styleMetadata, this.columnsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.headerColumnMetadata;
    }
}

class TemplateColumn extends propertyTypes.Serializable {
    private headerMetadata = new propertyTypes.TranslatableTextProperty("header", "Header")
    public header: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private templateColumnMetadata: propertyTypes.BaseProperty[];

    public childColumns: Column[];

    constructor() {
        super();
        this.templateColumnMetadata = [this.headerMetadata, this.widthMetadata, this.templateMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateColumnMetadata;
    }
}

class SimpleColumn extends propertyTypes.Serializable {
    private headerMetadata = new propertyTypes.TranslatableTextProperty("header", "Header")
    public header: string;

    private columnNameMetadata = new propertyTypes.ColumnProperty("columnName", "ColumnName", "dataSource")
    public columnName: string;

    private alignMetadata = new propertyTypes.SelectProperty("align", "Align")
        .addOption("left", "Left")
        .addOption("center", "Center")
        .addOption("right", "Right");
    public align: string;

    private formatMetadata = new propertyTypes.TextProperty("format", "Format");
    public format: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    private showSumMetadata = new propertyTypes.CheckBoxProperty("showSum", "Show sum in footer");
    public showSum: string;

    private simpleColumnMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.simpleColumnMetadata = [this.headerMetadata, this.columnNameMetadata, this.alignMetadata, this.formatMetadata, this.widthMetadata, this.showSumMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.simpleColumnMetadata;
    }
}

class ArrayColumn extends propertyTypes.Serializable {

    private nestedColumnMetadata = new propertyTypes.TextProperty("nestedColumn", "Nested column name");
    public nestedColumn: string;

    private keyFieldMetadata = new propertyTypes.TextProperty("keyField", "Key field");
    public keyField: string;

    private columnsMetadata = new propertyTypes.ObjectListPropertyExt("columns", "Child columns")
        .addStateImplementation("simpleColumn", GeneratorColumn);

    public columns: GeneratorColumn[];

    private generatorColumnMetadata: propertyTypes.BaseProperty[] = [this.nestedColumnMetadata, this.keyFieldMetadata, this.columnsMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.generatorColumnMetadata;
    }
}

class GroupingField extends propertyTypes.Serializable {

    private groupingFieldMetadata = new propertyTypes.ColumnProperty("groupingField", "Grouping field", "dataSource")
    public groupingField: string;
    private sortDirectionMetadata = new propertyTypes.SelectProperty("sortDirection", "Sort direction")
        .addOption("asc", "asc")
        .addOption("desc", "desc");
    public sortDirection: string;

    private generatorColumnMetadata: propertyTypes.BaseProperty[] = [this.groupingFieldMetadata, this.sortDirectionMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.generatorColumnMetadata;
    }
}

class GeneratorColumn extends propertyTypes.Serializable {

    private valueFieldMetadata = new propertyTypes.TextProperty("valueField", "Value field");
    public valueField: string;

    private headerFieldMetadata = new propertyTypes.TextProperty("headerField", "Header field");
    public headerField: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    private formatMetadata = new propertyTypes.TextProperty("format", "Format");
    public format: string;

    private alignMetadata = new propertyTypes.SelectProperty("align", "Align")
        .addOption("left", "Left")
        .addOption("center", "Center")
        .addOption("right", "Right");
    public align: string;

    private showSumMetadata = new propertyTypes.CheckBoxProperty("showSum", "Show sum in footer");
    public showSum: string;

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private generatorColumnMetadata: propertyTypes.BaseProperty[] = [this.valueFieldMetadata, this.headerFieldMetadata, this.widthMetadata, this.formatMetadata, this.alignMetadata, this.showSumMetadata, this.templateMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.generatorColumnMetadata;
    }
}



function FindDataSourceProperties(source: propertyTypes.Serializable): propertyTypes.BaseProperty[] {
    const foundTypes: propertyTypes.BaseProperty[] = [];

    for (let i of source.getMetadata()) {
        if (source[i.ValueField] && source[i.ValueField].getDataSourceIdentifier) {
            foundTypes.push(source[i.ValueField]);
        }
    }
    return foundTypes;
}